import React from 'react';
import { Box, IconButton, Popper } from '@mui/material';
import { LockIcon } from 'components/SVG';
import NewExpandIcon from 'components/SVG/NewExpandIcon';
import BoardNodeOptions from './BoardNodeOptions';
import { Toolbar } from 'external/TipTapEditor/components/ui/Toolbar';
import type { ListOptionsType } from 'types/common/DropdownOption';

type NodeOptionsBubbleMenuProps = {
  onExpandClick?: () => void;
  options: { default: ListOptionsType[]; nodeSpecific: ListOptionsType[] };
  isReadOnly?: boolean;
  isReadOnlyMode?: boolean;
  isCanvasView?: boolean;
  anchorEl: HTMLElement | null;
  isPopoverOpen: boolean;
  closePopover: () => void;
  fileTypeSpecificOptions?: React.ReactNode;
};
function NodeOptionsBubbleMenu({
  onExpandClick,
  isReadOnly,
  isReadOnlyMode,
  isCanvasView,
  options,
  anchorEl,
  isPopoverOpen,
  closePopover,
  fileTypeSpecificOptions,
}: NodeOptionsBubbleMenuProps) {
  const menuRef = React.useRef<HTMLDivElement>(null);

  const handleMenuClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const handleMenuMouseDown = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <Popper
      open={isPopoverOpen}
      anchorEl={anchorEl}
      placement='top'
      sx={{ zIndex: 1200 }}
    >
      <Box
        ref={menuRef}
        bgcolor={'white'}
        display='flex'
        flexWrap='nowrap'
        px={1.5}
        gap={1}
        borderRadius={'40px'}
        sx={{ border: '2px solid #eeeeee' }}
        marginY={isCanvasView ? 1 : 1.5}
        alignItems='center'
        onClick={handleMenuClick}
        onMouseDown={handleMenuMouseDown}
      >
        {options.nodeSpecific.map((option, index) => (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center' }}>
            {option.icon}
          </Box>
        ))}
        {options.nodeSpecific.length > 0 && <Toolbar.Divider />}
        {isCanvasView && (
          <>
            <IconButton onClick={onExpandClick}>
              <NewExpandIcon />
            </IconButton>
            {fileTypeSpecificOptions}
          </>
        )}
        {isReadOnly && (
          <IconButton disabled>
            <LockIcon />
          </IconButton>
        )}
        {!isReadOnlyMode && (
          <IconButton aria-label='close' onClick={() => {}} size='small'>
            <BoardNodeOptions options={options.default} />
          </IconButton>
        )}
      </Box>
    </Popper>
  );
}

export default NodeOptionsBubbleMenu;
